"use strict";
var PostponedFlightsConfig = (function () {
    function PostponedFlightsConfig() {
    }
    return PostponedFlightsConfig;
}());
exports.PostponedFlightsConfig = PostponedFlightsConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/postponed-flights-view-config.model.js